import { getBundleCourses } from "../_services/bundle.service";
import { bundleConstants } from "../_constants/bundle.constants";
export const fetchBundle = () => (dispatch) => {
  dispatch({ type: bundleConstants.FETCH_START });
  getBundleCourses()
    .then((data) => {
      if (data) {
        dispatch({
          type: bundleConstants.SET_BUNDLE_COURSES,
          payload: data.data.reverse(),
        });
      }
    })
    .catch((error) => dispatch({ type: bundleConstants.FETCH_END }));
};
